import { type QueryKey } from "@tanstack/react-query";
import create, { SetState } from "zustand";

export type PendingFeedbackTask = { taskId: string; queryKeys: QueryKey[]; topics?: string[] };

type FeedbackTaskTrackerState = {
	pendingTasks: PendingFeedbackTask[];
	// Watch an enqueued bulk task and invalidate `queryKeys` once it finishes — the bulk
	// endpoints return on enqueue (202), so the feedback row isn't written yet at mutation time.
	// `topics` are PubSub events published on completion for consumers (e.g. the Redux-backed
	// dashboard widget) that can't be refreshed via React Query invalidation.
	track: (taskId: string, queryKeys: QueryKey[], topics?: string[]) => void;
	untrack: (taskId: string) => void;
};

export const useFeedbackTaskTrackerStore = create<FeedbackTaskTrackerState>(
	(set: SetState<FeedbackTaskTrackerState>) => ({
		pendingTasks: [],
		track: (taskId, queryKeys, topics) =>
			set((state) =>
				state.pendingTasks.some((t) => t.taskId === taskId)
					? state
					: { pendingTasks: [...state.pendingTasks, { taskId, queryKeys, topics }] }
			),
		untrack: (taskId) => set((state) => ({ pendingTasks: state.pendingTasks.filter((t) => t.taskId !== taskId) })),
	})
);
